/*** IMPORTS FROM imports-loader ***/
var define = false;

export default class Util
{
    static scroll(selector, offset, speed = 400) {
        $('html, body').animate({
            scrollTop: $(selector).offset().top + offset
        }, speed);
    }

    /**
     * @param selector
     * @returns {boolean}
     */
    static isExist(selector) {
        return (document.querySelector(selector) !== null);
    }

    static isZero(val) {

        return +val == 0;
    }

    static isMoreOrZero(val) {

        return +val >= 0;
    }

    static isLessOrZero(val) {

        return +val <= 0;
    }

    static isMoreZero(val) {

        return +val > 0;
    }

    /**
     *
     * @param email
     */
    static isEmailValid( email )
    {
        return email.match(/^[-!#$%&\'*+\\.\/0-9=?a-zA-Z^_`{|}~]+@([a-zA-Z0-9\._-]+\.)+([0-9a-zA-Z]){2,}$/);
    }

    /**
     * @param val
     * @returns {boolean}
     */
    static isEmpty(val) {

        // test results
        //---------------
        // []        true, empty array
        // {}        true, empty object
        // null      true
        // undefined true
        // ""        true, empty string
        // ''        true, empty string
        // 0         false, number
        // true      false, boolean
        // false     false, boolean
        // Date      false
        // function  false

        if (val === undefined)
            return true;

        if (typeof (val) == 'function' || typeof (val) == 'number' || typeof (val) == 'boolean' || Object.prototype.toString.call(val) === '[object Date]')
            return false;

        if (val == null || val.length === 0)        // null or 0 length array
            return true;

        if (typeof (val) == "object") {
            // empty object

            let r = true;

            for (let f in val)
                r = false;

            return r;
        }

        return false;
    }

    /**
     * @param title
     * @param link
     */
    static linkPopup(title, link) {
        window.open(
            link,
            title,
            'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600'
        );
    }
}



// WEBPACK FOOTER //
// ./app/Sites/AT/assets/js/modules/libs/Util.js